import { render, staticRenderFns } from "./shopButton.vue?vue&type=template&id=337b3508&scoped=true"
import script from "./shopButton.vue?vue&type=script&lang=js"
export * from "./shopButton.vue?vue&type=script&lang=js"
import style0 from "./shopButton.vue?vue&type=style&index=0&id=337b3508&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "337b3508",
  null
  
)

export default component.exports